<template>
  <div class="common-grid-cards">
    <!--
      Скелетон только если данных ещё нет.
      Иначе при hydrate pending=true + items из SSR/pinia → mismatch (fragment vs div).
    -->
    <div v-if="pending && !items?.length" class="w-full flex gap-5">
      <SPSkeleton variant="card" :amount="3" />
    </div>

    <!-- Данные -->
    <div v-else-if="items?.length" class="cards-grid">
      <template v-for="(item, index) in items" :key="index">
        <slot name="card" :item="item" />
      </template>
    </div>

    <!-- Пусто -->
    <div v-else class="text-center py-10">
      <slot name="empty">
        <p class="text-neutral-light">{{ emptyText }}</p>
      </slot>
    </div>
  </div>
</template>

<script lang="ts" setup generic="T">
import SPSkeleton from './SPSkeleton.vue'

defineOptions({
  name: 'CommonGridCards',
})

withDefaults(
  defineProps<{
    items?: any[]
    pending?: boolean
    emptyText?: string
    skeletonAmount?: number
    ui?: {
      wrapper?: string
    }
  }>(),
  {
    items: () => [],
    pending: false,
    skeletonAmount: 3,
    emptyText: 'Ничего не найдено',
  },
)
</script>

<style lang="scss" scoped>
.common-grid-cards {
  width: 100%;
}

.cards-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;

  @include max-lg {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @include max-md {
    grid-template-columns: 1fr;
  }
}
</style>
